import { InternalRefetchQueriesInclude } from '@apollo/client';
import {
  SmartlkVideoStreamCopyFromTemplateMutationInput,
  useCopyVideoStreamFromTemplateMutation,
} from '@shared/api/graphql/generated';
import { BaseMutationResultType, FetchPolicyKeys } from '@shared/api/graphql/types';

const useVideoStreamCopyFromTemplate = () => {
  const [mutation, mutationResult] = useCopyVideoStreamFromTemplateMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });

  const request = async (
    input: SmartlkVideoStreamCopyFromTemplateMutationInput,
    refetchQueries?: InternalRefetchQueriesInclude
  ) => {
    const mutationData = await mutation({
      variables: {
        input,
      },
      refetchQueries,
    });

    return {
      isOk: mutationData.data?.result?.ok,
      errors: mutationData.data?.result?.errors,
      videoStreamId: mutationData.data?.result?.videoStream?.id,
    };
  };

  const result: BaseMutationResultType = {
    error: mutationResult.error,
    loading: mutationResult.loading,
    called: mutationResult.called,
  };

  return { request, result };
};

export default useVideoStreamCopyFromTemplate;
